import React from "react";

import { Check } from "icons";

import { Steward } from "components/Common/TableStyle";

export const ASSOCIATE_BUSINESS_TERM_COLUMN = [
  {
    title: "Name",
    key: "name",
    dataIndex: "name",
    width: "40%",
  },
  {
    title: "Description",
    key: "description",
    dataIndex: "description",
    width: "50%",
  },
  {
    title: "",
    key: "checked",
    dataIndex: "checked",
    render: text =>
      text && <Check size={15} style={{ color: "rgb(34, 118, 251)" }} />,
    width: "10%",
  },
];

export const BUSINESS_TERM_COLUMNS = [
  {
    dataIndex: "name",
    key: "name",
    title: "Name",
    width: 100,
    fixed: "left",
  },
  {
    title: "Description",
    key: "description",
    dataIndex: "description",
    width: 250,
    render: text => <div className="whitespace-pre-line">{text}</div>,
  },
  {
    dataIndex: "drafter",
    key: "drafter",
    title: "Drafter",
    render: row => <Steward name={row?.name} title={row?.role} />,
    width: 150,
  },
  {
    dataIndex: "approver",
    key: "approver",
    title: "Approver",
    render: row => <Steward name={row?.name} title={row?.role} />,
    width: 150,
  },
];
